<template>
  <div>
    <v-image-upload
      @crop-success="cropSuccess"
      :no-square="true"
      :no-circle="true"
      :max-size="200"
      field="croppedImage"
      ki="0"
      lang-type="en"
      v-model="uploadVisible"
      ref="vImageUploadRef"
    >
      <div class="el-dialog__header" slot="step1-header">
        <span class="el-dialog__title">Select Profile Photo</span>
      </div>
      <div class="el-dialog__footer" slot="step1-footer">
        <el-button @click="cancelImageUpload">Cancel</el-button>
        <el-button type="primary" @click="uploadImage" disabled>Set as Profile Photo</el-button>
      </div>
      <div class="el-dialog__header" slot="step2-header">
        <span class="el-dialog__title">Select Profile Photo</span>
      </div>
      <div class="el-dialog__footer" slot="step2-footer">
        <el-button @click="cancelImageUpload">Cancel</el-button>
        <el-button type="primary" @click="uploadImage">Set as Profile Photo</el-button>
      </div>
    </v-image-upload>
  </div>
</template>

<script>
export default {
  name: "ImageUpload",
  props: {
    imageProp: {
      type: String,
      default: "croppedImage"
    }
  },
  data() {
    return {
      uploadVisible: false,
      croppedImage: ""
    };
  },
  methods: {
    cancelImageUpload() {
      this.$refs["vImageUploadRef"].off();
      this.resetImageComponent();
      this.$emit("cancel-image-upload");
    },
    showImageUpload() {
      this.uploadVisible = true;
    },
    resetImageComponent() {
      if (this.$refs.vImageUploadRef) {
        this.$refs.vImageUploadRef.sourceImgUrl = "";
        this.$refs.vImageUploadRef.setStep(1);
        this.$refs.vImageUploadRef.hasError = false;
      }
    },
    cropSuccess(data, field, key) {
      this.croppedImage = data;
    },
    uploadImage() {
      // prepare upload call will emit 'crop-success' with base64 encoded image string
      this.$refs["vImageUploadRef"].prepareUpload();
      if (!_.isEmpty(this.croppedImage)) {
        this.$emit("save-image", this.croppedImage);
      }
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
.el-dialog__header {
  padding: 10px 20px 10px;
  text-align: left;
}

.el-dialog__footer {
  text-align: right;
  position: absolute;
  bottom: 0;
  width: 90%;
}

>>> .vue-image-crop-upload .vicp-wrap {
  width: 450px;
  height: 400px;
}

>>> .vicp-close {
  display: none;
}

>>> .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left {
  float: left;
  margin: 0px 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/ImageUpload.vue